import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

import { RedFlagDetailScreen } from '@/features/red-flags/components/RedFlagDetailScreen';
import { requirePermission } from '@/lib/guards';

const searchSchema = z.object({
  // Set by timeline bubbles so the back link returns to the originating
  // surface — `history` → client detail History tab; `sessions` → the
  // sessions workspace. Default (absent) falls back to the red flags list.
  returnTab: z.enum(['history', 'sessions']).optional(),
});

export const Route = createFileRoute('/app/red-flags/$id')({
  beforeLoad: () => {
    requirePermission('red_flag:read');
  },
  validateSearch: searchSchema.parse.bind(searchSchema),
  component: ClinicalRedFlagDetailRoute,
  staticData: { crumb: 'Red flag' },
});

function ClinicalRedFlagDetailRoute() {
  const { id } = useParams({ from: '/app/red-flags/$id' });
  const { returnTab } = useSearch({ from: '/app/red-flags/$id' });
  return <RedFlagDetailScreen flagId={id} surface="clinical" returnTab={returnTab} />;
}
